import {main, navigateToHref, router, routes, setBreadcrumb, switchTo} from './main.js';
import {requestJSON} from './utils.js';

function showDesks() {
	// Load friends
	requestJSON('POST', routes["desk.list"], null, function (xhr) {
		let desks = xhr.response;

		setBreadcrumb([{title: "Desk"}]);
		switchTo(document.querySelector(".js-nav-desks"));

		main.textContent = '';

		let elem = document.createElement("section");
		elem.classList.add("tile");
		let desksElem = document.createElement("div");
		desksElem.classList.add("list-group");
		elem.appendChild(desksElem);

		for (let id in desks) {
			let d = desks[id];
			let desk = document.createElement("a");
			desk.classList.add("list-group-item");
			desk.href = "";
			desk.textContent = d.name;

			desksElem.appendChild(desk);
		}

		main.appendChild(elem);
	});
}

export {showDesks};
